import { Download, LayoutTemplate, Pencil, Play, Tag, Users } from 'lucide-react'

const FEATURES = [
	{
		icon: Pencil,
		title: 'Rapid Play Creation',
		description: 'Draw routes, place players, save. Done in under a minute.',
	},
	{
		icon: LayoutTemplate,
		title: 'Smart Formations',
		description: 'Reusable formations and concepts. Build once, use everywhere.',
	},
	{
		icon: Play,
		title: 'Instant Animation',
		description: 'Watch plays come to life. See timing and spacing instantly.',
	},
	{
		icon: Tag,
		title: 'Custom Labels',
		description: 'Tag plays by situation, personnel, or concept. Filter your entire playbook in a click.',
	},
	{
		icon: Users,
		title: 'Share with Your Staff',
		description: 'Share playbooks with coaches on your staff. Everyone stays on the same page.',
	},
	{
		icon: Download,
		title: 'Professional Export',
		description: 'Export to PowerPoint or PDF. Presentation-ready in one click.',
	},
]

export function FeaturesGrid() {
	return (
		<section id="features" className="landing-features-section">
			<div className="landing-features-container">
				<div className="landing-features-header">
					<h2 className="landing-section-title">Everything you need</h2>
					<p className="landing-section-subtitle">
						Built for coaches who want to spend less time drawing and more time coaching
					</p>
				</div>

				<div className="landing-features-grid">
					{FEATURES.map((feature, index) => (
						<div
							key={feature.title}
							className="landing-feature-card"
							style={{ animationDelay: `${index * 100}ms` }}
						>
							<div className="landing-feature-card-header">
								<div className="landing-feature-icon">
									<feature.icon />
								</div>
								<h3 className="landing-feature-title">{feature.title}</h3>
							</div>
							<p className="landing-feature-description">{feature.description}</p>
						</div>
					))}
				</div>
			</div>
		</section>
	)
}
